var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('bar-graph',{attrs:{"series":_vm.series,"chartOptions":_vm.chartOptions}}),_c('b-link',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"href":"#"}},[_vm._v("View Full Report")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"subtitle"},[_vm._v("INPUT DISTRIBUTION")])])
}]

export { render, staticRenderFns }